import React, { useEffect, useState } from 'react';
import { ReactComponent as ChatCX } from "../assets/svg/채팅상담.svg"
import { ReactComponent as CleanCenter } from "../assets/svg/피드백.svg";
import { Link, useNavigate } from 'react-router-dom';
import jwt_decode from 'jsonwebtoken/decode';
import axios from 'axios';

import Header from '../component/Header';
import Footer from '../component/Footer';
import { getApiUrl } from '../utils/api';
import Clock from '../assets/img/clock-img.webp';
import ImageSlider from '../component/ImageSlider';
import SliceBar from '../component/SliceBar';


const reasons = [
  '사용방법을 잘 모르겠어요',
  '기대 했던것과 달라요',
  '알람이 작동을 안해요',
  '카카오계정이 내 이름이 아니에요',
  '기타',
];

function CS() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [npsScore, setNpsScore] = useState(null);
  const [deletionReason, setDeletionReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [alarmCount, setAlarmCount] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 관리자 체크
        const token = localStorage.getItem('token');
        if (token) {
          try {
            const decodedToken = jwt_decode(token);
            const userId = decodedToken.user_id;
            // 관리자 ID 목록 (필요에 따라 수정)
            const adminIds = ['admin', 'kkokkio_admin', 'test_admin', 'user_8iX8yEuB4jve5', 'user_5SNYw6oKx8FYF'];
            setIsAdmin(adminIds.includes(userId));
          } catch (tokenError) {
            console.error('Token decode error:', tokenError);
          }
        }

        // 알람 수 가져오기
        const response = await fetch('https://api.kkokk.io/api/alarm/count');
        if (!response.ok) {
          throw new Error('알람 수를 가져오는 데 실패했습니다');
        }
        const data = await response.json();
        setAlarmCount(data.alarmCount);

        // 기존 로딩 완료
        setIsLoading(false);
      } catch (error) {
        console.error('API Error:', error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  // 로딩 중일 때는 아무것도 렌더링하지 않음
  if (isLoading) {
    return null;
  }

  const handleDeleteAccount = async () => {
    if (!npsScore || !deletionReason || (deletionReason === '기타' && !customReason)) {
      alert('모든 항목이 작성되지 않아, 탈퇴 처리가 힘들어요.');
      return;
    }

    const token = localStorage.getItem('token');


    if (!token) {
      alert('계정 탈퇴는, 로그인 후에 진행할 수 있어요');
      navigate('/V4/Start');
      return;
    }

    setIsDeleting(true);

    const decodedToken = jwt_decode(token);
    const tokenUserID = decodedToken.user_id;
    const tokenUserNo = decodedToken.user_no;


    try {
      if (deletionReason !== '기타') {
        await axios.post(getApiUrl() + '/logging/delete', {
          user_id: tokenUserID,
          user_no: tokenUserNo,
          user_nps: npsScore,
          user_reason: deletionReason,
        });
      } else {
        await axios.post(getApiUrl() + '/logging/delete', {
          user_id: tokenUserID,
          user_no: tokenUserNo,
          user_nps: npsScore,
          user_reason: customReason,
        });
      }


      localStorage.removeItem('token');
      localStorage.removeItem('VisitprofileID');
      localStorage.removeItem('VisitprofileName');

      alert('계정이 성공적으로 탈퇴 처리되었습니다.');
      setShowPopup(false);
    } catch (error) {
      alert('계정 삭제 실패에 실패했어요. 고객센터로 문의주세요');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleNpsChange = (score) => {
    setNpsScore(score);
  };

  const handleReasonChange = (reason) => {
    if (reason === '기타') {
      setDeletionReason('기타');
    } else {
      setDeletionReason(reason);
    }
  };

  const handleCustomReasonChange = (event) => {
    setCustomReason(event.target.value);
    setDeletionReason('기타');
  };

  const handlePopupOpen = () => {
    setShowPopup(true);
  };

  const handlePopupOpen2 = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user_id')
    localStorage.removeItem('loginDate')
    localStorage.removeItem('loginDate')
    alert('계정이 성공적으로 로그아웃 되었어요');
  };

  const handlePopupOpen3 = () => {
    localStorage.clear();
    alert('모든 캐시가 삭제되었어요');
  };
  const handlePopupClose = () => {
    setShowPopup(false);
  };

  return (
    <div className="main" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="main_content" style={{ backgroundColor: '#FFFFFF' }}>
        <div>
          <br></br>

          <div style={{ marginTop: '20px' }}>
            <Header Text={'꼬끼오 사용자 센터'} back_disable={true}></Header>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px', cursor: 'pointer' }}>
            <Link to="https://pf.kakao.com/_TtXiG">
              <ChatCX></ChatCX>
            </Link>
            <div style={{ marginRight: '10px' }} ></div>
            <Link to="https://slashpage.com/kkokkio">
              <CleanCenter></CleanCenter>
            </Link>
          </div>

          <SliceBar></SliceBar>

          <p style={{
            color: '#6E747D',
            fontFamily: 'Pretendard',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            marginTop: '30px',
            letterSpacing: '-0.84px',
          }}>사용자가 늘어나면, 더 많은 기능이 찾아와요 <br></br> 전 국민의 쪽잠을 보장하는 그 순간까지 함께할게요</p>

          <ImageSlider></ImageSlider>

          <div>
            <img
              src={Clock}
              width='130px'
              initial={{ scale: 1 }}
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ repeat: Infinity, duration: 0.5 }}
              style={{ marginTop: '50px' }}
            />

            <p style={{
              color: '#DE4C3C',
              textAlign: 'center',
              fontFamily: 'Pretendard',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
              letterSpacing: '-1px',
              marginTop: '20px',
            }}>
              꼬끼오 알람이 함께한 모두의 쪽잠 수<br></br>

              <span style={{ color: '#000000', fontSize: '40px' }}>{alarmCount.toLocaleString()}번</span>
            </p>
          </div>







          <div style={{ display: 'flex', marginTop: '30px', textAlign: 'center', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
            <p style={{ textDecoration: 'underline', color: '#404040', fontSize: '13px' }} onClick={handlePopupOpen2}>로그아웃</p>

            <p style={{ textDecoration: 'underline', color: '#404040', fontSize: '13px', marginLeft: '25px' }} onClick={handlePopupOpen3}>모든 캐시 삭제</p>

            <Link to="https://kkokkio.channel.io/">
              <p style={{ textDecoration: 'underline', color: '#404040', fontSize: '13px', marginLeft: '25px' }}>카톡 알림 그만 받기</p>
            </Link>

            <p style={{ textDecoration: 'underline', color: '#404040', fontSize: '13px', marginLeft: '25px' }} onClick={handlePopupOpen}>계정 탈퇴</p>

            {isAdmin && (
              <Link to="/ad-test">
                <p style={{ textDecoration: 'underline', color: '#DE4C3C', fontSize: '13px', marginLeft: '25px', fontWeight: '600' }}>광고 테스트</p>
              </Link>
            )}
          </div>

        </div>
        <Footer></Footer>

      </div>


      {showPopup && (
        <div className="popup-container" onClick={handlePopupClose}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h2>꼬끼오 알람과 <br></br>함께해주셔서, 감사했어요 😢</h2>
            <p>꼬끼오 알람의 사용경험은 5점 만점에 어느정도 였나요?</p>
            <div className="nps-container">
              {[1, 2, 3, 4, 5].map((score) => (
                <div
                  key={score}
                  className={`nps-option ${npsScore === score ? 'selected' : ''}`}
                  onClick={() => handleNpsChange(score)}
                >
                  {score}
                </div>
              ))}
            </div>
            <p>탈퇴 사유를 선택해주세요:</p>
            <div className="reason-container">
              {reasons.map((reason) => (
                <div
                  key={reason}
                  className={`reason-option ${deletionReason === reason ? 'selected' : ''}`}
                  onClick={() => handleReasonChange(reason)}
                >
                  {reason}
                </div>
              ))}
              {deletionReason === '기타' && (
                <input
                  type="text"
                  value={customReason}
                  onChange={handleCustomReasonChange}
                  placeholder="탈퇴 사유를 직접 입력해주세요."
                  className="custom-reason-input"
                  style={{ fontFamily: 'Pretendard', '::placeholder': { fontFamily: 'Pretendard' } }}
                />
              )}
            </div>
            <p>탈퇴 진행시, 내 정보는 삭제되고<br></br>꼬끼오 알람의 일부 기능을 이용할 수 없어요 😶‍🌫️</p>
            <div className="button-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button
                className="delete-button"
                onClick={handleDeleteAccount}
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <div className="spinner"></div>
                ) : (
                  '탈퇴'
                )}
              </button>
              <button
                className="retry-button"
                onClick={handlePopupClose}
                disabled={isDeleting}
              >
                다시 한번 써볼게요
              </button>
            </div>
          </div>

        </div>
      )}
    </div>
  );
}

const styles = `
.spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.delete-button:disabled,
.retry-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default CS;
